import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, EditSettingsModel, FilterSettingsModel, GridComponent, IFilter, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { ServiceDeliveryPlan, serviceplanformBO } from '../serviceplan-form/serviceplan-form.model';
import { ColumnChangeBO, columnWidth, GetGroupPayorServiceBO, WhereCondition } from '../group-payor-mapping/group-payor-mapping.model';
import { Observable, Subject } from 'rxjs';
import { CommonApiService } from 'src/app/commonapiservice';
import { takeUntil } from 'rxjs/operators';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GetServicePlanBO ,ChangeSdpStatusBO, permission, SDP} from './serviceplan.model';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { functionpermission } from '../client-parent/client-parent.model';
import { IMyDpOptions } from 'mydatepicker';
import { DateService } from 'src/app/date.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { EventsServices } from '../events/events.service';
import { GetEventListBo } from '../events/events.modal';
import { EventsShareService } from '../events/eventsShare.service';
import { ConsultationServices } from '../consultation-services/consultation-services.service';

@Component({
  selector: 'app-serviceplan',
  templateUrl: './serviceplan.component.html',
  styleUrls: ['./serviceplan.component.scss']
})
export class ServiceplanComponent implements OnInit, AfterViewInit {
  toast: any;
  UserDropDownList: any;
  StatusList: any;
  clientname: any;
  EventList: any;
  ServiceList: any;
  ContactList: any;
  viewevent :boolean=false;
  saveAuthErr: string;
  msg: string;
  clientConfirmation : boolean = false;
    SDPTotalColumns:number=15;

  constructor(public global: GlobalComponent, public CommonAPI: CommonApiService, public formbuilder: FormBuilder, public toastrService: ToastrService , public dateservice: DateService,
    private sanitizer:DomSanitizer ,  public datepipe: DatePipe,public EventService: EventsServices,  private eventsShare: EventsShareService , public CSService: ConsultationServices
  ) {
    // this.global.agencyList();
    this.data = CommonAPI;


  }
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild("pdfServiceDeliveryPlanlist") pdfservicedeliveryplanlist;
  @Input() planInput: ServiceDeliveryPlan = new ServiceDeliveryPlan();
  @Output() dataemitplanimport = new EventEmitter<serviceplanformBO>();
  initialPage: object;
  filterOptions: FilterSettingsModel;
  public toolbar: ToolbarItems[];
  filter: IFilter;

  serviceImprtPlan: any = [];

  filterstatusList: any;
  FilterStatus: any;
  ListSendBO: GetServicePlanBO = new GetServicePlanBO();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  ColumnArray: columnWidth[]
  columnchange: ColumnChangeBO = new ColumnChangeBO();

  id: number = 0;
  arraycol: any = [];
  public isinitialLoad: boolean = false;
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  public filterSettings: object;

  public formatOptions: object;
  ServicePlanImportData: ServiceDeliveryPlan = new ServiceDeliveryPlan();
  logintype: string = null;
  singledata: any = []

  LinkStatus: any = [];
  selectAllValue: boolean = false;

  result4: any = [];
  isCheckedBool: boolean = false;
  Type: any;

  public checkparams;

  public editSettings: EditSettingsModel;
  public selectionOptions: SelectionSettingsModel;
  sdpupload : SDP = new SDP();
  selectedDocumentFileName:any;
  ApproveFilter : any ="All";
  modelTypename = ['AGENCY', 'BUDGET'];
  public myDatePickerOptions: IMyDpOptions = {
      dateFormat: 'mm/dd/yyyy',
      // disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
      showClearDateBtn: false,
      editableDateField: true
    };
    GridDataEvent :any;
    languageList:any = [];
    isevent : boolean = false;
    eventdata :GetEventListBo = new GetEventListBo();

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.grid && window.innerWidth <= 768) {
        this.grid.autoFitColumns();
      }
    }, 1000);

  }

  ngOnInit(): void {
this.clearGridLocalStorage();
    this.status = "active"
    console.log(this.status, "status==========");

    this.filterOptions = { type: 'Menu' };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.logintype = localStorage.getItem("CFSS_checkType");
    this.getServicePlanList();
    if(this.logintype !='onboardLogin'){
      this.getLanguageList();
      this.GetUserDropDownList();
      this.GetStatusLovDropDown();
      this.GetLovDropDown();
      this.GetContactType();
      this.GetServiceType();
      this.Getclientmodelandlanguage();
    }
    this.editSettings = { allowEditing: false, mode: 'Normal', allowEditOnDblClick: true }
   
    this.selectionOptions = {
      checkboxOnly: true
    }
    this.checkparams =
    {
      checked: false
    }
this.getpermission();
  }

  dataEmitFromCDCSPlan(event) {
    this.ServicePlanImportData.edit = false;
    this.status = "active"
    console.log(this.status, "status");

    this.getServicePlanList();
    // this.getOnBoardFilter();
    //this.BudgetImportData.isabasicadvance = false;
  }


  closemodal() {

  }
  status: any = 'active';
  statusChangeCall(val) {
    this.ListSendBO.status = val;
    this.getServicePlanList();
  }

  serviceImport() {
    this.ServicePlanImportData = new ServiceDeliveryPlan();
    if (this.planInput.clientId != '00000000-0000-0000-0000-000000000000'
      && this.planInput.clientId != null && this.planInput.clientId != undefined) {
      this.ServicePlanImportData.clientId = this.planInput.clientId;
    } else {
      if (this.global.OnboardType == "CLIENT") {
        this.ServicePlanImportData.clientId = this.global.cfssLoginEntityId;
      }
    }


    this.ServicePlanImportData.edit = true;
    this.ServicePlanImportData.id = '00000000-0000-0000-0000-000000000000';
    this.serviceImprtPlan = null

  }
  editServiceplan(data) {

    this.serviceImprtPlan = data;
    this.ServicePlanImportData = data;
    this.ServicePlanImportData.edit = true;
    if (this.planInput.clientId != '00000000-0000-0000-0000-000000000000'
      && this.planInput.clientId != null && this.planInput.clientId != undefined) {
      this.ServicePlanImportData.clientId = this.planInput.clientId;
    } else {
      if (this.global.OnboardType == "CLIENT") {
        this.ServicePlanImportData.clientId = this.global.cfssLoginEntityId;
      }
    }
    // this.ServicePlanImportData.clientId = this.planInput.clientId;
  }

  CopyServiceplan() {

    this.serviceImprtPlan = this.singledata[0];
    this.ServicePlanImportData = this.singledata[0];;
    this.ServicePlanImportData.edit = true;
    this.ServicePlanImportData.copy = true;
    if (this.planInput.clientId != '00000000-0000-0000-0000-000000000000'
      && this.planInput.clientId != null && this.planInput.clientId != undefined) {
      this.ServicePlanImportData.clientId = this.planInput.clientId;
    } else {
      if (this.global.OnboardType == "CLIENT") {
        this.ServicePlanImportData.clientId = this.global.cfssLoginEntityId;
      }
    }

    this.ServicePlanImportData.id = '00000000-0000-0000-0000-000000000000';

    // this.ServicePlanImportData.clientId = this.planInput.clientId;
  }
  public onActionComplete(args) {
    this.ListSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.ListSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];

    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.ListSendBO.type = args.columnType
    }
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
  
  }
  deleteDetails: any;
  DeleteServicePlanDetails(data) {
    this.deleteDetails = data;
  }

  DeleteServiceplan() {
    let params = new URLSearchParams();
    params.append("ServicedeliveryplanId", this.deleteDetails.serviceDeliveryPlanId);
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/DeleteServiceDeliveryPalan?";
      }
      else{

         url = "api/ServiceDeliveryPlan/DeleteServiceDeliveryPalan?";
      }
    this.CommonAPI.DeleteFunctionForDeleteHttp(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Service Delivery Plan deleted successfully!")
      document.getElementById('openModal2').click();
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      this.getServicePlanList();
    }, (err: any) => {
      this.toastrService.error(err, 'Error'), 8000;
    });
  }
  Refresh() {
    this.ListSendBO.field = 'ClientName';
    this.ListSendBO.value = "";
    this.ListSendBO.currentpageno = 1;
    this.ListSendBO.status = 'Active';
    let page = 10;
    this.ListSendBO.pageitem = page;
    this.getServicePlanList();
    this.grid.clearFiltering();
    this.grid.clearSorting();
    setTimeout(() => {
      if (this.grid && window.innerWidth <= 768) {
        this.grid.autoFitColumns();
      }
    }, 1000);
  }
  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].name;
        this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      // this.ListSendBO.field = state.action.currentFilterObject.field;
      // this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      // this.ListSendBO.operator = state.action.currentFilterObject.operator;
      // this.ListSendBO.value = state.action.currentFilterObject.value;
      // this.ListSendBO.type = state.action.currentFilterObject.type;


      if (this.ListSendBO.type == "number") {
        this.ListSendBO.value = state.action.currentFilterObject.value.toString();
        this.ListSendBO.field = state.action.currentFilterObject.field;


      }
      else if (this.ListSendBO.type == "date") {
        this.ListSendBO.value = (new Date((new Date(state.action.currentFilterObject.value)).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");

        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.ListSendBO.value = state.action.currentFilterObject.value;
        this.ListSendBO.field = state.action.currentFilterObject.field;





        this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
        this.ListSendBO.operator = state.action.currentFilterObject.operator;

      }
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "ClientName";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "contains";
        this.ListSendBO.value = "";
        this.ListSendBO.type ="string";
      }
    } if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].GrouppayorService.Pagesize != state.take) {
          this.arraycol[0].GrouppayorService.Pagesize = state.take
          // this.SaveColumnwidth();
        }
      }
    }
    this.getServicePlanList();
  }
  ServicePlanList: any = [];
  getServicePlanList() {
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_ServiceDeliveryPlan/GetServiceDeliveryPlanList?";
      }
      else{

         url = "api/ServiceDeliveryPlan/GetServiceDeliveryPlanList?";
      }

    if (this.ApproveFilter == "All") {
      this.ListSendBO.isApproved = null;
    } else if (this.ApproveFilter == "Approve") {
      this.ListSendBO.isApproved = true;
    } else {
      this.ListSendBO.isApproved = false;
    }
    let responseData =
    {
      result: "result",
      count: "count",
    }
    this.ListSendBO.status = this.status?.toString()
    if (this.planInput.clientId != '00000000-0000-0000-0000-000000000000'
      && this.planInput.clientId != null && this.planInput.clientId != undefined) {
      this.ListSendBO.clientId = this.planInput.clientId;
    } else {
      if (this.global.OnboardType == "CLIENT") {
        this.ListSendBO.clientId = this.global.cfssLoginEntityId;
      }
    }
    // this.ListSendBO.clientId=this.planInput.clientId;
    this.CommonAPI.outputValues(url, this.ListSendBO, responseData, "");
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ServicePlanList = data.result;
      count = count + 1
      if (data != null && data != undefined && count == 1) {
        if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
          // this.getColumnwidth();
        }
      }
      // data.result.forEach(element => {
      //   element.groupPayorId = element.groupPayorId.toString();
      // });
      // if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
      //   if (data != null && data.result.length > 15) {
      //     this.grid.height = '500';
      //   }
      //   else {
      //     this.grid.height = 'auto';
      //   }
      // }
    })

  }
  showtable() {
    // this.updategrpser = false;
    // this.Addgrpser = false;
  }
  show() {
    this.grid.columnChooserModule.openColumnChooser(500, -250);
  }

  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();

    }
  }


  ///........................................show1....................................................


  CheckboxChange(args: any): void {

    var customselect = [];
    this.singledata = [];
    if (args.checked && args.target.classList.contains('e-checkselectall')) {
      //   if (this.selIndex.length) {
      //     this.grid.selectRows(this.selIndex);
      //     this.selIndex = [];
      // }
      this.selectAllValue = true;

      this.Type = 1;
      var row1: any = this.grid.getSelectedRecords();

      this.planIds = row1.map(t => t.serviceDeliveryPlanId)
    
      this.LinkStatus = [];
      row1.forEach(element => {
        this.LinkStatus.push(element.claimStatus)
      });

      var selectedrow = this.grid.getRowInfo(args.target)
      let resultantdata: any = selectedrow.rowData;
      row1.forEach(element => {
        if (element.claimStatus == 'Ready') {
          let serialNo = element.serialNo;
          // this.TimesheetList.forEach(element => {
          //   if (element.serialNo == serialNo) {
          //   }
          // });
        }
      });
      if (this.LinkStatus.some(isStatus => isStatus === "Validate")) {
        this.isCheckedBool = true;
      }
      else {
        this.isCheckedBool = false;
      }

      for (var i = 0; i < args.selectedRowIndexes.length; i++) {
        var row = this.grid.getRowByIndex(args.selectedRowIndexes[i]);
        if (!row.querySelector('.disablecheckbox')) {
          customselect.push(args.selectedRowIndexes[i])
        }
      }
      this.grid.selectRows(customselect)
    }
    else {
      let rowfilter: any = this.grid.getSelectedRecords();
      this.singledata = rowfilter;
      console.log(rowfilter, "rowfilter=====");

      this.LinkStatus = [];
       this.planIds = rowfilter.map(t => t.serviceDeliveryPlanId)
       console.log(this.planIds,"planIds=========");
       


      this.selectAllValue = false;
      this.Type = 2;
      let result = this.grid.getRowInfo(args.target)
      this.result4 = result.rowData;
      if (args.checked) {
        console.log('Checked');

        //    this.selectsingleValue = true;
        // this.singledata = this.TimesheetList.filter(findItem =>
        //   rowfilter.some(tlist => tlist.serialNo === findItem.serialNo && tlist.claimStatus != 'Validate')
        // );    
      }
      else {
        // this.singledata = this.TimesheetList.filter(findItem =>
        //   rowfilter.some(tlist => tlist.serialNo === findItem.serialNo)
        // );
      }
    }
  }


  //.....................................................evvMarkedCheckbox.............................................
  planIds: any = [];
   ChangeSdpStatusBO = new ChangeSdpStatusBO();
  planMarkedCheckbox(boolean) {
    this.ChangeSdpStatusBO.sdpIds = this.planIds;
 this.ChangeSdpStatusBO.status = boolean;
      let url = "api/ServiceDeliveryPlan/ChangeSdpApproveStatus";

    
      this.CommonAPI
        .saveorUpdateFunctionwithResponseTypeJson(this.ChangeSdpStatusBO, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            if(boolean ==true)
            {
              this.toastrService.success("Approved");
            
            }
            else{
              this.toastrService.success("Unapproved");
            
            }
           this.planIds = [];
            this.getServicePlanList();
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          },
          (err: any) => {
            this.toastrService.error(err, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
   
  }

fp:functionpermission =new functionpermission();

   getpermission() {
      if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
        let params = new URLSearchParams();
        params.append("pagecode", "Client");
        // params.append("roleId", this.global.roleId);
        // params.append("agencyId", this.global.globalAgencyId)
        let url = "api/FunctionPermission/getfunctionpermissionemployee?";
   
        this.CommonAPI.GetFunctionwithResponseTypeJson(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  
          if (data != null) {
            this.fp = data;
  
          }
          else {
            this.fp = new functionpermission();
          }
        },
          (err: HttpErrorResponse) => {
            this.fp = new functionpermission();
          })
      }
    }
    tobase64 = value => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(value);
      reader.onload = (e: any) => resolve(e.target.result);
      reader.onerror = error => reject(error);
    });
    pdfsrc:any;
    async  savesdp(val) {
      let url = "api/ServiceDeliveryPlan/UploadSDPDocument";
      // this.isSaveorUpdateBoolean=true;
        console.log("val",val);
        let basevalue: any;
        if (val.fileString != null && val.fileString != undefined) {
          basevalue = await this.tobase64(this.sdpupload.fileString);
          console.log("basevalue",basevalue);
          val.fileString = basevalue;
        }
        this.sdpupload.startdate = this.global.getDateTimeString(this.sdpupload.startdate);
        this.sdpupload.plandate = this.global.getDateTimeString(this.sdpupload.plandate);
        this.sdpupload.enddate = this.global.getDateTimeString(this.sdpupload.enddate);
        this.sdpupload.clientId = this.global.clientId;

        this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(val,url).pipe(takeUntil(this.onDestroy$)).subscribe(
         
          (data: any) => {
            this.toastrService.success("SDP Plan Upload Successfully")
            // document.getElementById("templateNameModal").click();
            this.clientname = this.global.clientName;
            this.isevent = false;
            this.sdpupload.serviceDeliveryPlanId = data.id;
            this.sdpupload.plandate = this.datepipe.transform(data.plandate, "MM/dd/yyyy");
            this.sdpupload.startdate = this.datepipe.transform(data.startdate, "MM/dd/yyyy");
            this.sdpupload.enddate = this.datepipe.transform(data.enddate, "MM/dd/yyyy");
            this.selectedDocumentFileName = data.sdpDocFilePath;
            this.sdpupload.totalCFSSUnitsEligible = data.totalCFSSUnitsEligible;
            this.sdpupload.modelTypename = data.modelTypename
            this.sdpupload.version = data.version;
            this.sdpupload.sdpDocFilepath = null;
            this.sdpupload.fileString = null;
            this.getServicePlanList();
            this.eventdisable = false;
            console.log(data,"./.,.//.,,.//")
            
           
    
          }, (err: any) => {
           this.toastrService.error(err), 8000;
    
          });
      }
  onDOCFileChanged(files) {
   
        console.log("files",files);
        let val = files.item(0);
        this.sdpupload.fileString = files.item(0);
        this.selectedDocumentFileName = files.item(0)?.name;
        this.sdpupload.sdpDocFilepath = files.item(0)?.name;
        // this.sdpupload.f= files.item(0)?.name;
        if(files.item(0)?.length==0){
          this.selectedDocumentFileName=''
        }
      }
      newdates(event, type, name) {
        if (type == "inputchage") {
          if (name == 'plandate') {
            let val = this.dateservice.inputFeildchange(event);
            if (val != undefined) {
              let val1 = this.dateservice.inputFeildchange(event);
              this.sdpupload.plandate = val1;
              this.EventButtonDisable();
    
            }
          }
    
          if (name == 'startdate') {
            let val = this.dateservice.inputFeildchange(event);
            if (val != undefined) {
              let val1 = this.dateservice.inputFeildchange(event);
              this.sdpupload.startdate = val1;
              this.EventButtonDisable();
              
            }
          }
          if (name == 'enddate') {
            let val = this.dateservice.inputFeildchange(event);
            if (val != undefined) {
              let val1 = this.dateservice.inputFeildchange(event);
              this.sdpupload.enddate = val1;
              this.EventButtonDisable();
          
            }
          }
      

        } 
    
        if (type == "datechagned") {
          if (name == 'startdate') {
            let val = this.dateservice.Datechange(event);
            if (val != undefined) {
              let val1 = this.dateservice.Datechange(event);
              this.sdpupload.startdate = val1;
              this.EventButtonDisable();
            
            }
          }
    
          if (name == 'enddate') {
            let val = this.dateservice.Datechange(event);
            if (val != undefined) {
              let val1 = this.dateservice.Datechange(event);
              this.sdpupload.enddate = val1;
              this.EventButtonDisable();
             
            }
          }
          if (name == 'plandate') {
            let val = this.dateservice.Datechange(event);
            if (val != undefined) {
              let val1 = this.dateservice.Datechange(event);
              this.sdpupload.plandate = val1;
              this.EventButtonDisable();
              
            }
          }
   
    
    
    
        }
      }
     
      uploadSPD(){
        this.selectedDocumentFileName = '';
        this.sdpupload = new SDP();
         document.getElementById('templateNameModal').click();
      }
      editUploadSDP(data){
        console.log(data);
        // this.sdpupload = data
        console.log(this.sdpupload,"<><><><><>")
        this.sdpupload.plandate = this.datepipe.transform(data.plandate, "MM/dd/yyyy");
        this.sdpupload.startdate = this.datepipe.transform(data.startdate, "MM/dd/yyyy");
        this.sdpupload.enddate = this.datepipe.transform(data.enddate, "MM/dd/yyyy");
        this.selectedDocumentFileName = data.sdpDocFilePath;
        this.sdpupload.totalCFSSUnitsEligible = data.cfssTotalUnits;
        this.sdpupload.modelTypename = data.modeltypeName
        this.sdpupload.version = data.version;
        this.clientname = data?.clientName;
        this.isevent = data?.hasEvent;
        this.sdpupload.serviceDeliveryPlanId = data.serviceDeliveryPlanId
         document.getElementById('templateNameModal').click();
      }
      downloadFile(data) {
        var data1 = data.returnString;
        if (data1 != null) {
          window.open(data1);
        }
      }

      viewFile(id) {

        let params=new URLSearchParams();
        this.pdfsrc = null;
        params.append("ServiceDeliveryPlanId",id);
        let url;
        if(this.global.OnboardingLoginType =='onboardLogin')
          {
             url = "api/Client_ServiceDeliveryPlan/getSDPDocBase64?";
          }
          else{
    
             url = "api/ServiceDeliveryPlan/getSDPDocBase64?";
          }
       this.CommonAPI.GetFunctionwithResponseTypeText(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        console.log("data",data)
         if (data) {
          document.getElementById("ViewHandbook22").click();
           this.pdfsrc = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data);
           console.log("pdfsrc",this.pdfsrc);
         }
       },
         (err: any) => {
          this.toast.error(err, "Error");
         })
      }
      eventdisable: boolean = false;
      EventButtonDisable() {
        this.eventdisable = true;
      }
    
    
      createEvents() {
    
        let serviceplan: ServiceDeliveryPlan = JSON.parse(JSON.stringify(this.sdpupload));
    
        let url = "api/ServiceDeliveryPlan/CreateEventsForSDP?";
    
        let params = new URLSearchParams();
        params.append("Id",  this.sdpupload.serviceDeliveryPlanId);
    
        this.CommonAPI.saveorUpdateFunctionwithParams(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
         this.GridDataEvent = data;
         this.GridDataEvent.forEach(event => {
          event.getConfirmation = true;
          event.isCheckboxDisabled = false;
          event.noCallMessage = '';
          this.OutBoundCall(event, event.startTime, event.endTime);
         })
         if (!this.GridDataEvent || this.GridDataEvent.length === 0) {
          this.addEvent(); 
        }
          
        }, (err: any) => {
          if (err) {
            this.toastrService.error(err);
          }
          else {
            this.toastrService.error(err);
          }
    
        })
    
    
      }
      getLanguageList() {
        let url = "api/Language/GetLanguageList";
        this.CommonAPI
          .GetFunctionwithResponseTypeJson("", url)
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            (data) => {
              this.languageList = data;
              this.languageList.forEach(element => {
                element.id = element.id.toString()
              });
            },
            (err: any) => {
              this.toastrService.error(err);
            }
          );
      }
      removeEvent(index: number) {
        if (this.GridDataEvent.length > 1) {
            this.GridDataEvent.splice(index, 1);
        }
    }
    GetUserDropDownList() {
      this.EventService.GetUserDropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.UserDropDownList = data;
      },
        (err: any) => {
          if (err) {
            this.toastrService.error(err, 'Error'), 8000;
          }
        })
    }
    GetStatusLovDropDown() {
      let params = new URLSearchParams();
      params.append("ListCode", "EVENTSTATUS");
      this.EventService.getLovValues(params).subscribe((data: any) => {
        this.StatusList=data
     
      })
    }
    addEvent() {
      if (!this.GridDataEvent || this.GridDataEvent.length === 0){
        this.GridDataEvent.push({
          clientName: this.clientname,
          consultantId: null,
          startTime: null,
          endTime: null,
          eventTitle: '',
          eventDescription: '',
          statusLid: null,
          cfssModel: this.sdpupload.modelTypename,
          languageListIds: [],
          typeofContactId: null,
          typeofServiceId: null,
          eventAlterList: [],
          isInvalid: false,
          isOverlapping: false,
          clientId : this.global.clientId,
          serviceDeliveryPlanId : this.sdpupload.serviceDeliveryPlanId,
          getConfirmation: true,
          isCheckboxDisabled: false,
          noCallMessage: ''
        });
      }
      else{
        this.GridDataEvent.push({
          ...this.GridDataEvent[0], 
          startTime: '',  
          endTime: ''   ,
          eventDescription : ''  ,
          getConfirmation: true ,
          isCheckboxDisabled: false,
          noCallMessage: ''
      });
      }
    
    }
    
    submitted = false;
    validateGridDataEvent() {
      const isInvalid = this.GridDataEvent?.some((item: any) => {
        const start = new Date(item?.startTime);
        const end = new Date(item?.endTime);
        if (start?.toDateString() !== end?.toDateString()) {
          return true; 
        }
      });
      if (isInvalid) {
        this.toastrService.error("Start and End date must be on the same day.");
        return false;
      }
      return true;
    }
    saveEvent(){
      if (!this.validateGridDataEvent()) {
        return;
      }
      this.submitted = true;
      // Check if all required fields are filled
      const isValid = this.GridDataEvent?.every(event => 
          event?.consultantId && event?.startTime && event?.endTime && event?.eventTitle && event?.statusLid
      );
    
      if (!isValid) {
          this.toastrService.error("Please Fill all Mandatory Field")
          return;
      }
    
      let url = "api/Event/SaveEventList";
      this.CommonAPI
        .saveorUpdateFunctionwithResponseTypeText(this.GridDataEvent, url)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.toastrService.success("Events created Successfully");
            this.getServicePlanList();
            this.isevent = true;
            document.getElementById('createeventTrigger').click();
          },
          (err: any) => {
            this.toastrService.error(err);
          }
        );
    }
    GetLovDropDown() {
      let params = new URLSearchParams();
      params.append("ListCode", "EVENTALERT");
    
      this.EventService.getLovValues(params).subscribe((data: any) => {
        this.EventList = data?.map(element => ({
          eventAlertId: element.id,
          eventAlterName: element.lovName,  
    
    
          eventAlertValue: element.lovValue,
          id: element.id,
          isCheck: true
        }));
        const defaultEvent = this.EventList.find(e => e.eventAlterName === "1 hour before").eventAlertId;
    
        this.GridDataEvent?.forEach(event => {
          event.eventAlterList = defaultEvent ? [defaultEvent] : [];
        });
      });
    }
    
    
    
    updateSelectedEventAlerts(event) {
      event.eventAlterList = event?.eventAlterList.map(eventId => {
        let selectedEvent = this.EventList?.find(e => e.eventAlertId === eventId);
        if (selectedEvent) {
          return { ...selectedEvent, isCheck: true }; 
        }
        return {};
      });
    }
    
    compareEventAlerts(event1: any, event2: any): boolean {
      return event1 && event2 ? event1.eventAlertId === event2.eventAlertId : event1 === event2;
    }
    
    sendEventdata(){
      this.eventdata.startDate = this.sdpupload.startdate;
      this.eventdata.endDate = this.sdpupload.enddate;
      this.eventdata.clientId = this.global.clientId;
      this.eventdata.serviceDeliveryPlanId = this.sdpupload.serviceDeliveryPlanId;
      this.eventdata.isedit = true;
      this.global.isSDPtoEvent = true;
      this.eventsShare.updateFilterData(this.eventdata)
      document.getElementById('manageeventTrigger').click();
    }
    GetContactType() {
      let params = new URLSearchParams();
      params.append("ListCode", "SESSIONCONTACTTYPE");
      this.EventService.getLovValues(params).subscribe((data: any) => {
        this.ContactList = data;
      })
    }
    async GetServiceType(): Promise<void> {
      return new Promise((resolve, reject) => {
        // if (this.saveBo.clientId != null && this.saveBo.clientId != undefined) {
          let params = new URLSearchParams();
          // params.append("ClientId", this.saveBo.clientId)
          this.CSService.getServiceValues(params).subscribe((data: any) => {
            this.ServiceList = data;
            
            resolve(data);
            // if (this.ServiceList.length == 0) {
            //   this.saveBo.typeofServiceId = null;
            // }
            // else{
            //   this.saveBo.typeofServiceId= this.saveBo.typeofServiceId;
            // }
          })
          resolve();
          this.ServiceList = [];
      });
    }
    
    validateEventTimes() {
      this.GridDataEvent.forEach((event, index) => {
        // Ensure startTime and endTime are valid dates
        if (!event.startTime || !event.endTime) {
          event.isInvalid = true; // Flag invalid event
          return;
        }
    
        const startTime = new Date(event.startTime).getTime();
        const endTime = new Date(event.endTime).getTime();
    
        // Check if end time is greater than start time
        event.isInvalid = endTime <= startTime;
    
        // Check for overlapping events
        for (let i = 0; i < this.GridDataEvent.length; i++) {
          if (i !== index) {
            const otherEvent = this.GridDataEvent[i];
            if (otherEvent.startTime && otherEvent.endTime) {
              const otherStartTime = new Date(otherEvent.startTime).getTime();
              const otherEndTime = new Date(otherEvent.endTime).getTime();
    
              if (
                (startTime >= otherStartTime && startTime < otherEndTime) ||  // Overlapping start
                (endTime > otherStartTime && endTime <= otherEndTime) ||  // Overlapping end
                (startTime <= otherStartTime && endTime >= otherEndTime)  // Full overlap
              ) {
                event.isOverlapping = true;
                return;
              }
            }
          }
        }
        event.isOverlapping = false;
      });
    }
    checkvalidation() {
  
      if (this.sdpupload.plandate == null || this.sdpupload.plandate == "" || this.sdpupload.plandate == undefined) {
        this.saveAuthErr = "Plan date is important";
        this.toastrService.error(this.saveAuthErr);
      }
  
      else if (this.sdpupload.startdate == null || this.sdpupload.startdate == "" || this.sdpupload.startdate == undefined) {
        this.saveAuthErr = "Start date is important";
        this.toastrService.error(this.saveAuthErr);
      }
  
  
      else if (this.sdpupload.enddate == null || this.sdpupload.enddate == "" || this.sdpupload.enddate == undefined) {
        this.saveAuthErr = "End date is important";
        this.toastrService.error(this.saveAuthErr);
      }
  
      else if (this.sdpupload.version == null || this.sdpupload.version == "" || this.sdpupload.version == undefined) {
        this.saveAuthErr = "Version is important";
        this.toastrService.error(this.saveAuthErr);
      }
  
      else if (this.sdpupload.totalCFSSUnitsEligible == null || this.sdpupload.totalCFSSUnitsEligible == 0 || this.sdpupload.totalCFSSUnitsEligible == undefined) {
        this.saveAuthErr = "Total CFSS units is important";
        this.toastrService.error(this.saveAuthErr);
      }
  
      else if (new Date(this.sdpupload.startdate).getTime() > new Date(this.sdpupload.enddate).getTime()) {
  
        this.saveAuthErr = "End date must be larger than start date";
        this.toastrService.error(this.saveAuthErr);
  
      }
      else if (this.sdpupload.modelTypename == null || this.sdpupload.modelTypename == "" || this.sdpupload.modelTypename == undefined) {
  
        this.saveAuthErr = "CFSS Model type is empty";
        this.toastrService.error(this.saveAuthErr);
  
      }
      else {
        this.saveAuthErr = '';
      }
      if (this.saveAuthErr == "") {
        
  
        this.createEvents();
  
  
      }
  
  
    }
    OutBoundCall(event :any ,StartDate ,EndDate ) {
      console.log(event , StartDate ,EndDate )
    const currentDateTime = new Date();
    const EventStartdate = new Date(StartDate);
    const EventEnddate = new Date(EndDate);

    // Extract business hours (only hr & min)
    const businessStartTime = new Date(this.global.businessStartTime);
    const businessEndTime = new Date(this.global.businessEndTime);
    const startHour = businessStartTime.getHours();
    const startMin = businessStartTime.getMinutes();
    const endHour = businessEndTime.getHours();
    const endMin = businessEndTime.getMinutes();

    // Build today/tomorrow markers
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    // Build today's business window
    const businessStartToday = new Date(today);
    businessStartToday.setHours(startHour, startMin, 0, 0);

    const businessEndToday = new Date(today);
    if (endHour < startHour)
      businessEndToday.setDate(businessEndToday.getDate() + 1);
    businessEndToday.setHours(endHour, endMin, 0, 0);

    // Build next‐day business start
    const nextDayBusinessStart = new Date(tomorrow);
    nextDayBusinessStart.setHours(startHour, startMin, 0, 0);

    const fifteenMinutes = 15 * 60 * 1000;
    const eventTime = EventStartdate.getTime();
    const currentTime = currentDateTime.getTime();

    const isToday = EventStartdate.toDateString() === today.toDateString();
    const isTomorrow = EventStartdate.toDateString() === tomorrow.toDateString();
    event.noCallMessage = '';
    event.isCheckboxDisabled = false;
    event.getConfirmation = true;
  console.log(today , tomorrow , isToday , isTomorrow , businessStartToday , businessEndToday ,nextDayBusinessStart )
   console.log( this.global.isValidCcxAccessKey ,this.clientConfirmation  , currentTime , eventTime , EventStartdate , currentDateTime )

    if (
      this.global.isValidCcxAccessKey &&
      this.clientConfirmation &&
      (isToday || isTomorrow) 
    ) {
      if( isToday && eventTime < currentTime)
      {
          event.getConfirmation = false;
          event.isCheckboxDisabled = true;
          event.noCallMessage = "Event time is passed";
      } 
      else if( isToday && eventTime <= currentTime +fifteenMinutes)
        {
           event.noCallMessage= "short notice";
           event.getConfirmation = false;
           event.isCheckboxDisabled = true;
          //  document.getElementById("openNoCallModel")?.click();
        }
      // 1st: Today & within business hours (±15min)
      else if (isToday && eventTime < businessStartToday.getTime()+fifteenMinutes) {
        event.noCallMessage = "Outside of business hours";
        event.getConfirmation = false;
        event.isCheckboxDisabled = true;

        // document.getElementById("openNoCallModel")?.click();
      }
     else if (
        isToday &&
        currentTime < businessEndToday.getTime() - fifteenMinutes &&
        eventTime > businessStartToday.getTime() + fifteenMinutes
      ) {
        event.getConfirmation = true;
        // document.getElementById("opencallModel")?.click();

        // 2nd: Today but after business end, before next day's start+15
      } else if (
        isToday || isTomorrow &&
        currentTime > businessEndToday.getTime() - fifteenMinutes &&
        eventTime < nextDayBusinessStart.getTime() + fifteenMinutes
      ) {
        event.noCallMessage = "Outside of business hours"
        event.getConfirmation = false;
        event.isCheckboxDisabled = true;
        // document.getElementById("openNoCallModel")?.click();

        // 3rd: Event is beyond next day's start +15 → allow call
      } 
       else if (eventTime > nextDayBusinessStart.getTime() + fifteenMinutes) {
        event.getConfirmation = true;
      }
       else {
        event.getConfirmation = true;
        //  this.SaveEvents();
       }
    } 
    else {

      event.getConfirmation = true;
      
        }
  }
    Getclientmodelandlanguage() {
    let url = "api/Event/GetEventClientData?";

    let params = new URLSearchParams();
    params.append("clientId", this.global.clientId);
    this.EventService.getDropdown(url + params)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            console.log(data, "data===================");
            this.clientConfirmation = data[0].clientConfirmation;
          }
        )
    }
      clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridSDPGrid', expectedColumns: this.SDPTotalColumns },
    ];
    
    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
    
}